import subscription_set from "../datafiles/subscription_set.json";
import bankData from "../datafiles/bank_set.json";
import { IMemberData } from "../ApiTS/CommonType";
import moment from "moment";

// 랜덤 숫자
export const randomNum = (lower: number, upper: number) => {
  for (var i = 0; i < 8; i++) {
    let myRandom = Math.floor(Math.random() * (upper - lower + 1)) + lower;

    return myRandom;
  }
};

// serviceId로 subscription 구하기
export const GetSubsDataByServiceId = (svcID: number) => {
  const SubsData = subscription_set.filter((data) => data.SVC_ID === svcID);
  return SubsData;
};

// hide 상태 제외 subscription 구하기
export const GetSubsDataNoHideByServiceId = (svcID: number) => {
  const SubsData = subscription_set.filter(
    (data) =>
      data.SVC_ID === svcID &&
      data.SUBS_ACT !== "hide" &&
      moment().isBetween(
        moment(data.SUBS_ADATE).format("YYYY-MM-DD HH:mm"),
        moment(data.SUBS_EDATE).format("YYYY-MM-DD HH:mm")
      )
  );
  return SubsData;
};

// bankCode로 은행 데이터 구하기
export const getBankInfoByBankCode = (bankCode: string) => {
  const bank = bankData.find((b) => b.bankCode === bankCode);
  return bank;
};

interface IUrl {
  [key: string | number]: any;
}

// search 값 파싱하기
export const getURLParams = (url: string) => {
  var result = {};
  url.replace(
    /[?&]{1}([^=&#]+)=([^&#]*)/g,
    (str: any, key: string, value: string) => {
      (result as IUrl)[key] = decodeURIComponent(value);

      return str;
    }
  );
  return result;
};

// 파티 정보 > 멤버 정보 정렬하기 (파티장 - 파티원 순으로)
export const sortFromPartyOwner = (memberData: IMemberData[]) => {
  let i = 0;

  while (i < memberData?.length) {
    if (memberData[i].grade === 0) {
      let tmp = memberData[i];
      memberData[i] = memberData[0];
      memberData[0] = tmp;
      break;
    }
    i++;
  }
};

// 파티 채팅 방해 금지 시간 슬라이더
export const sliderValueConverter = (value: number) => {
  let sValue = Number(value);

  if (value < 22) {
    sValue = value + 24;
  }

  switch (sValue) {
    case 22:
      return "22";
    case 23:
      return "23";
    case 24:
      return "00";
    case 25:
      return "01";
    case 26:
      return "02";
    case 27:
      return "03";
    case 28:
      return "04";
    case 29:
      return "05";
    case 30:
      return "06";
    case 31:
      return "07";
    case 32:
      return "08";
    case 33:
      return "09";
    case 34:
      return "10";

    default:
      return "00";
  }
};

// 링키드 계절 이벤트 배경 색상
export const seasonEventBgColor = (eventName: string) => {
  let bgColor = "";

  switch (eventName) {
    case "spring_2022":
      bgColor = "#f2f4fd";
      break;

    default:
      bgColor = "#f4f4fa";
      break;
  }

  return bgColor;
};

// 브라우저 탐지
export const fnBrowserDetect = () => {
  let userAgent = navigator.userAgent;

  let browserName;

  if (userAgent.match(/NAVER/i)) {
    browserName = "naver";
  } else if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }

  return browserName;
};

// 접속 플랫폼 탐지
export const getWhichPlatform = () => {
  const platform = navigator.platform.toLowerCase();

  if (platform.indexOf("iphone") != -1) {
    return "apple";
  } else if (platform.indexOf("ipad") != -1) {
    return "apple";
  } else if (platform.indexOf("ipod") != -1) {
    return "apple";
  } else {
    return "notApple";
  }
};

// string 안에서 url 찾아 a tag로 교체
export const findUrl = (text: string) => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

  return text?.replace(urlRegex, (url) => {
    return "<a>" + url + "</a>";
  });
};
